/* One-line headings that never overflow (homepage, layout/theme.liquid).

   An element with data-bm-fit="<px>" is fitted at that width and narrower
   (e.g. data-bm-fit="749": phones). Its lines are its [data-bm-fit-line]
   children, or the element itself. The script adds .bm-fit (CSS then keeps
   each line on one line), measures each line's rendered width against its
   available width, and lowers the element's font size in 0.5px steps,
   all lines together, until every line fits; never below
   data-bm-fit-min (default 16px). Where the lines fit, the size set in
   CSS (the section's size slider) is kept exactly. Elements with the same
   data-bm-fit-group get the same (smallest) size.

   Without the script the lines wrap normally (no .bm-fit), so nothing
   runs off the screen. */
(function () {
  'use strict';

  function lines(el) {
    var list = el.querySelectorAll('[data-bm-fit-line]');
    return list.length ? Array.prototype.slice.call(list) : [el];
  }

  function overflows(el) {
    return lines(el).some(function (line) {
      return line.scrollWidth > line.clientWidth + 0.5;
    });
  }

  function fit() {
    var groups = {};
    document.querySelectorAll('[data-bm-fit]').forEach(function (el) {
      el.style.removeProperty('font-size');
      var max = parseFloat(el.getAttribute('data-bm-fit')) || 749;
      if (!window.matchMedia('(max-width: ' + max + 'px)').matches) {
        el.classList.remove('bm-fit');
        return;
      }
      el.classList.add('bm-fit');
      var min = parseFloat(el.getAttribute('data-bm-fit-min')) || 16;
      var size = parseFloat(window.getComputedStyle(el).fontSize);
      while (overflows(el) && size > min) {
        size = Math.max(min, size - 0.5);
        el.style.setProperty('font-size', size + 'px', 'important');
      }
      var group = el.getAttribute('data-bm-fit-group');
      if (group) (groups[group] = groups[group] || []).push({ el: el, size: size });
    });
    Object.keys(groups).forEach(function (name) {
      var items = groups[name];
      var smallest = Math.min.apply(null, items.map(function (i) { return i.size; }));
      items.forEach(function (i) {
        if (i.size > smallest) i.el.style.setProperty('font-size', smallest + 'px', 'important');
      });
    });
  }

  var timer;
  function later() {
    window.clearTimeout(timer);
    timer = window.setTimeout(fit, 100);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fit);
  else fit();
  window.addEventListener('load', fit);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  window.addEventListener('resize', later);
  window.addEventListener('orientationchange', later);
  ['shopify:section:load', 'shopify:section:select', 'shopify:section:reorder', 'shopify:block:select'].forEach(function (name) {
    document.addEventListener(name, later);
  });
})();
